import React, 
{ 
    useEffect,
    useState 
} from 'react'

import toast from 'react-hot-toast';
import dayjs from 'dayjs';

import { 
    Delete,
    Edit,
} from '@mui/icons-material';

import { 
    Form,
    Input,
    Col, 
    Row,
    Table,
    Space,
    Button,
    DatePicker,
} from 'antd';

import { usePostRequest } from '../../hooks/usePostRequest'

const BillingRefundableDep = ({refundableData, fetchMembersData, isLoading, id}) => {
    const { callPost, loading } = usePostRequest(()=>{
        fetchMembersData();
    });
    const [refundableInfo, setRefundableInfo] = useState([]);


    const handleDelete = (key) => {
        const newData = [...refundableInfo];
        newData.splice(key, 1); 
        setRefundableInfo(() => newData)
    };
      
    const addRow = () => {
        const newData = [...refundableInfo];
        newData.push({
            refdep_ors: '',
            refdep_dates: undefined,
            refdep_amounts: '',
            refdep_cvs: '',
            refdep_remarks: '',
            isWritable: true,
        });
        setRefundableInfo(newData);
    };

    const handleTable = (e, index, name, isDate) => {
        if(isDate){
            setRefundableInfo(prevState => {
                const newState = [...prevState];
                newState[index] = { 
                    ...newState[index],
                    [name]: e
                };
                return newState;
            });
        } else {
            const { value } = e.target

            setRefundableInfo(prevState => {
            const newState = [...prevState];
            newState[index] = { 
                ...newState[index],
                [name]: value
            };
            return newState;
            });
        }
    }

    const handleRowClick = (row_id) => {
        const newData = refundableInfo?.map((item, index) => ({
          ...item,
          isWritable: row_id === index ? !item.isWritable : item.isWritable,
        }));
        setRefundableInfo(newData);
    };

    const defaultColumns = [
        {
            title: 'OR',
            dataIndex: 'refdep_ors',
            align: 'center',
            key: 'refdep_ors',
            render: (_, record, index) => (
            record.isWritable ? (
                
                <Input
                    value={record.refdep_ors}
                    onChange={(e) => handleTable(e, index, "refdep_ors")}
                />
            ) : record.refdep_ors
          ),
        },
        {
            title: 'Date',
            dataIndex: 'refdep_dates',
            align: 'center',
            key: 'refdep_dates',
            render: (_, record, index) => (
            record.isWritable ? (
                <DatePicker        
                    style={{width:'100%'}}
                    value={record.refdep_dates}
                    onChange={(e) => handleTable(e, index, "refdep_dates", true)}
                />
            ) : record.refdep_dates?.format('MMMM D, YYYY')
          ),
        },
        {
            title: 'Amount',
            dataIndex: 'refdep_amounts',
            align: 'center',
            key: 'refdep_amounts',
            render: (_, record, index) => (
            record.isWritable ? (
                <Input
                    value={record.refdep_amounts}
                    onChange={(e) => handleTable(e, index, "refdep_amounts")}
                />
            ) : record.refdep_amounts
          ),
        },
        {
            title: 'CV',
            dataIndex: 'refdep_cvs',
            align: 'center',
            key: 'refdep_cvs',
            render: (_, record, index) => (
            record.isWritable ? (
                <Input
                    value={record.refdep_cvs}
                    onChange={(e) => handleTable(e, index, "refdep_cvs")}
                />
            ) : record.refdep_cvs
          ),
        },
        {
            title: 'Remark',
            dataIndex: 'refdep_remarks',
            align: 'center',
            key: 'refdep_remarks',
            render: (_, record, index) => (
            record.isWritable ? (
                <Input
                    value={record.refdep_remarks}
                    onChange={(e) => handleTable(e, index, "refdep_remarks")}
                />
            ) : record.refdep_remarks
          ),
        },
        {
            title: '',
            dataIndex: '',
            align: 'center',
            render: (_, record, index) => (
                <Space>
                    {
                        (record.id) && (
                            <div 
                                onClick={() => handleRowClick(index)}
                                className='cursor'
                            >
                                <Edit/>
                            </div>
                        )
                    }
                    <div 
                        onClick={() => handleDelete(index)}
                        className='cursor'
                    >
                        <Delete  
                            style={{
                                color: 'red',
                            }}
                        />
                    </div>
                </Space>
            ),
            onCell: () => ({
                onClick: (e) => {
                e.stopPropagation();
                },
            }),
        },
    ];
    
    const handleCreateRefundable = () => {
        try{
            const newValues = {
                member_id: id,
                id: [],
                refdep_ors: [],
                refdep_dates: [],
                refdep_amounts: [],
                refdep_remarks: [],
                refdep_cvs: [],
            }

            refundableInfo?.forEach(item => {
                newValues.id.push(item.id || "");
                newValues.refdep_ors.push(item.refdep_ors || "");
                newValues.refdep_amounts.push(item.refdep_amounts || "");
                newValues.refdep_cvs.push(item.refdep_cvs || "");
                newValues.refdep_remarks.push(item.refdep_remarks || "");
                newValues.refdep_dates.push(item.refdep_dates ? item.refdep_dates.format("YYYY-MM-DD") : "");
            });

            callPost(
                "members/update_refundable_dep", 
                newValues,
                false,
            );
        }catch(errorInfo){
            toast.error('Validation Failed ', errorInfo);
        };
    };

    const validateArray = (array) => {
        return array.every((item) => {
            return item.refdep_ors !== "" || item.refdep_dates !== undefined || item.refdep_remarks !== "" || item.refdep_cvs !== "" || item.refdep_amounts !== "" ;
        });
    };  

    useEffect(() => {
        if(refundableData){
            const admission_data = refundableData?.map((data) => ({
                id: data.id,
                member_id: data.member_id,
                refdep_ors: data.or,
                refdep_dates: data.date ? dayjs(data.date) : undefined,
                refdep_amounts: data.amount,
                refdep_cvs: data.cv,
                refdep_remarks: data.remark,
                added_by: data.added_by,
                added_on: data.added_on,
                updated_by: data.updated_by,
                updated_on: data.updated_on,
                is_deleted: data.is_deleted,
            }))
             
            setRefundableInfo(admission_data)
        }
    }, [refundableData])
 
    return (
        <Row className='tab-container custom-padding'>
            <Col span={24}>
                <Form 
                    layout="vertical"
                >
                    <Row>
                        <Col span={24} className='responsive-overflow-y'>
                            <Table
                                bordered
                                dataSource={refundableInfo}
                                columns={defaultColumns}
                                pagination={false}
                                loading={isLoading}
                                scroll={{ x: 800 }} 
                            />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-4' >
                        <Col span={24}>
                            <Button 
                                type="primary" 
                                onClick={addRow}
                            >
                                Add Row
                            </Button>
                        </Col>
                    </Row>
                    <Row className='btn-footer'>
                        <Space className='p-2'>
                            <Button
                                onClick={handleCreateRefundable}
                                loading={loading}
                                type='primary'
                                disabled={!validateArray(refundableInfo)}
                                className='button-color btn-header'
                            >
                                Save
                            </Button>
                        </Space>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}
export default BillingRefundableDep
